module.exports = __webpack_public_path__ + "img/16.4ef2a740.png";